<template>
  <footer>
    <!-- <div class="pageTop">
      <a @click="toTop"
        ><span class="arrow relative">このページのトップへ</span></a
      >
    </div> -->
    <div class="copyright">
      <p class="copyright__txt">
        Copyright &copy; eggsy株式会社 All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
footer {
  width: 100%;
}
footer .copyright {
  width: 100%;
  background: #01365e;
  text-align: center;
  padding: 25px 0;
  margin-top: 20px;
}
footer .copyright__txt {
  color: #fff;
  font-size: 2vw;
}
@media screen and (min-width: 980px) {
  footer .copyright {
    padding: 20px 0;
    margin-top: 50px;
  }
  footer .copyright__txt {
    font-size: 14px;
  }
}
</style>
